<div>
    <input type="text" placeholder="RECHERCHE PAR ID" class="form-control"
           [(ngModel)]="searchSession"
           (keypress)="onKeyPress($event)"/>
    <span *ngIf="sessionSearchError"
          class="alert alert-warning">{{sessionSearchError}}</span>
</div>


// WEBPACK FOOTER //
// ./src/app/_screens/_shared/navigate-session-id/navigate-session-id.component.html